import useRenderEditor from 'src/hooks/useRenderEditor';
import XplorActiveNewsBodyEditor from 'src/components/common/contentEditor/XplorActiveNewsBodyEditor';
import { CKEditorEvent } from 'src/types/types';

type eventFn = (ckEvent: CKEditorEvent) => void;

interface OneOffXplorActiveNewsBodyEditorProps {
  events?: Record<string, eventFn>;
  config?: Record<string, unknown>;
  content?: string;
}

const OneOffXplorActiveNewsBodyEditor: React.FC<OneOffXplorActiveNewsBodyEditorProps> = ({
  config,
  events,
  content = '',
}) => {
  const { container, rendered } = useRenderEditor<HTMLDivElement>(false);

  return (
    <div ref={container} style={{ position: 'relative' }}>
      {rendered && (
        <XplorActiveNewsBodyEditor config={{ ...config }} events={events} content={content} />
      )}
    </div>
  );
};

export default OneOffXplorActiveNewsBodyEditor;
